<template>
  <vx-card>
    <template slot="no-body">
      <vs-button
        v-if="dataEdit"
        class="mt-3 mb-3 ml-2 shadow float-right mr-2"
        type="gradient"
        color="primary"
        gradient-color-secondary="#CE9FFC"
        @click="editGeo()"
        >{{ $t('Edit') }}
      </vs-button>
      <vs-button
        v-if="dataEdit"
        class="mt-3 mb-3 ml-2 shadow float-right mr-2"
        type="gradient"
        color="danger"
        gradient-color-secondary="#CE9FFC"
        @click="deleteGeo()"
        >{{ $t('Delete') }}
      </vs-button>
      <div
        class="flex flex-wrap pl-2 mt-3 mb-3 ml-4"
        style="padding-top: 20px !important">
        <h5>{{ geoName }} [{{ geoType }}]</h5>
      </div>
      <vs-divider style="margin-bottom: 0" />
      <div class="heights">
        <span></span>
        <GmapMap
          ref="mapRef"
          :center="center"
          :zoom="11"
          style="width: 100%; height: 100%"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false,
          }">
          <GmapPolygon> </GmapPolygon>
        </GmapMap>
      </div>
    </template>
  </vx-card>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'

export default {
  props: {
    geoName: String,
    geoType: String,
    dataEdit: Object,
    dataCoordinate: Array,
  },
  watch: {
    dataCoordinate: {
      immediate: true,
      handler(val, oldVal) {
        this.$nextTick(() => {
          if (!this.$refs.mapRef) return

          if (this.dataCoordinate.length > 0 && this.dataEdit.type != 'CIRCLE') {
            var self = this
            this.$refs.mapRef.$mapPromise.then((map) => {
            var poly = []
            if (this.drawingManager !== '') this.drawingManager.setMap(null)
            this.dataCoordinate.forEach((x) => {
              let tmp = new google.maps.LatLng(x['1'], x['0'])
              poly.push(tmp)
            })
            let color = '#FF0000'
            if (this.dataEdit.colour != '') {
              color = this.dataEdit.colour
            }
            this.drawingManager = new google.maps.Polygon({
              path: poly,
              draggable: false,
              editable: false,
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.35,
              map: map,
            })
            // ("center");
            map.fitBounds(this.drawingManager.getBounds())
          })
        }

        if (this.dataCoordinate.length > 0 && this.dataEdit.type == 'CIRCLE') {
          var self = this
          this.$refs.mapRef.$mapPromise.then((map) => {
            var poly = []
            if (this.drawingManager !== '') this.drawingManager.setMap(null)
            
            // Format for CIRCLE: dataCoordinate is array [lng, lat]
            let center = {
              lat: Number(this.dataCoordinate[1]),
              lng: Number(this.dataCoordinate[0]),
            }

            let color = '#FF0000'
            if (this.dataEdit.colour != '') {
              color = this.dataEdit.colour
            }
            this.drawingManager = new google.maps.Circle({
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.35,
              map: map,
              center: center,
              radius: Number(this.dataEdit.radius),
            })
            // this.drawingManager = new google.maps.Polygon({
            //     path: poly,
            //     draggable: false,
            //     editable: false,
            //     strokeColor: color,
            //     strokeOpacity: 0.8,
            //     strokeWeight: 2,
            //     fillColor: color,
            //     fillOpacity: 0.35,
            //     map: map
            // });
            // ("center");
            map.setCenter(center)
            map.setZoom(14)
          })
        }
        })
      },
    },
  },
  computed: {
    dataCoordinateLocal: {
      get() {
        // ("List Coordinate");
        // (this.dataCoordinate);

        return JSON.parse(this.dataCoordinate)
      },
      set(val) {
        if (!val) {
          // (val);
          this.$emit('closeModal')
        }
      },
    },
    google: gmapApi,
  },
  mounted() {
    // var self = this;
    this.$refs.mapRef.$mapPromise.then((map) => {
      google.maps.Polygon.prototype.getBounds = function () {
        var bounds = new google.maps.LatLngBounds()
        var paths = this.getPaths()
        var path
        for (var i = 0; i < paths.getLength(); i++) {
          path = paths.getAt(i)
          for (var ii = 0; ii < path.getLength(); ii++) {
            bounds.extend(path.getAt(ii))
          }
        }
        return bounds
      }
    })
  },
  data() {
    return {
      overlays: [],
      data_coordinate: [],
      drawingManager: '',
      selectedShape: '',
      selectedColor: '',
      colorButtons: {},
      colors: ['#1E90FF', '#FF1493', '#32CD32', '#FF8C00', '#4B0082'],
      center: { lat: -6.1498619, lng: 106.882887 },
    }
  },
  methods: {
    deleteGeo() {
      //
      this.$emit('deleteGeo')
      // this.$emit('closeModal');
    },
    editGeo() {
      this.$emit('editGeo', 'someValue')
      setTimeout(() => {
        this.$router.push(
          '/master-data/geofence-detail-update/' + this.dataEdit._id
        )
      }, 500)
    },
    submit() {
      // (this.drawingManager)
    },
  },
}
</script>
<style lang="scss">
.heights {
  height: calc(100vh - 15.1rem);
}
</style>
